import styled from 'styled-components';

export const HeaderPrintScheduleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SearchScheduleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
`;
